import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {Row} from 'reactstrap';

import { VerticalNumberAndLabel, MagstimColor, CurrentLang, isPDA } from "common";


class ChargeDelayControl extends React.Component {

    state = {
        isChecked: false,
        controlMargin:isPDA() ? 'margin: 0' :  'margin: 10px 20px 0',
        minLabelHeight:isPDA() ? '25px' :  '55px',
        toggleLabelMargin:isPDA() ? '20px' :  '30px',
    }
    constructor() {
        super();
		this._elemVerticalNumberAndLabel = React.createRef();
		this._elemLabelOff = React.createRef();
		this._elemLabelOn = React.createRef();
    }
  
    setChecked(value) {
        //console.log(`ChargeDelayControl.setChecked(${value})`, this);
        this.setIsEnabled(value);
        this.setState( {isChecked: value });
    }

	setHighlight(value) {
		// console.log(`ChargeDelayControl.setHighlight(${value})`, this);
		this._elemVerticalNumberAndLabel.current.setHighlight(value);
    }

    setIsEnabled(value) {
        this._elemVerticalNumberAndLabel.current.setIsEnabled(value);
    }

    isEnabled() {
        return this._elemVerticalNumberAndLabel.current.isEnabled();
    }
    
	onChangeIsEnabled = (event) => {
        // console.log('event=' + event);
        // console.log('event.target=' + event.target);
        // console.log('event.target.value=' + event.target.value);
        // console.log('event.target.id=' + event.target.id);
        // console.log('event.target.checked=' + event.target.checked);
        this.setChecked(event.target.checked);
        if ((undefined !== this.props.onChangeIsEnabled) && (null !== this.props.onChangeIsEnabled)) {
            this.props.onChangeIsEnabled(event.target.checked);
        }

    }
      
    render() {

        return (
            <Wrapper controlMargin={this.state.controlMargin} minLabelHeight={this.state.minLabelHeight} toggleLabelMargin={this.state.toggleLabelMargin} >

                <label>{CurrentLang().charge_delay_title}</label>

                <Row className="toggleLabels">
                    <label ref={this._elemLabelOff}>{CurrentLang().charge_delay_off}</label>
                    <div className='custom-control custom-switch'>
                        <input
                            type='checkbox'
                            className='custom-control-input'
                            id={this.props.id}
                            onChange={this.onChangeIsEnabled}
                            checked={this.state.isChecked}
                            readOnly
                        />
                        <label className='custom-control-label' htmlFor={this.props.id}></label>
                    </div>
                    <label  ref={this._elemLabelOn}>{CurrentLang().charge_delay_on}</label>

                </Row>

                <Row>
                    <VerticalNumberAndLabel 
                        onChange={this.props.onChangeDuration} 
                        ref={this._elemVerticalNumberAndLabel} 
                        defaultValue={this.props.defaultValue} 
                        text={CurrentLang().charge_delay_duration}
                        min={this.props.min} 
                        max={this.props.max} 
                        step={this.props.step} 
                        id={this.props.id} 
                        format={this.format_ms} 
                        size="lg"
                        />
                </Row>
            </Wrapper>
        );
    }

	format_ms(value) {
		return Number.parseFloat(value).toFixed(0) + CurrentLang().charge_delay_ms;
    }
    
	getValue() {
		return this._elemVerticalNumberAndLabel.current.getValue();
	}

    setValue(value) {
        this._elemVerticalNumberAndLabel.current.setValue(value);
    }

    componentDidMount() {
        this.setIsEnabled(this.props.isEnabled);
    }
}

ChargeDelayControl.propTypes = {
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.number,
    onChangeDuration: PropTypes.func,
    onChangeIsEnabled: PropTypes.func,
    defaultValue: PropTypes.number,
    isEnabled: PropTypes.bool,
    id: PropTypes.string
};

ChargeDelayControl.defaultProps = {
	min: 1,
	max: 1000,
	step: 1,
    onChangeDuration: undefined,
    onChangeIsEnabled: undefined,
    defaultValue: 1,
    isEnabled: true,
    id: "customSwitch"
};

const Wrapper = styled.div`
	margin: ${props => props.controlMargin};
    padding: 25px 10px;
    color: white;
    background:  ${ MagstimColor.MagstimGroupBackground};
    border: 1px solid #dee2e6;
    border-radius: .75rem;
    
    label {
        min-height: ${props => props.minLabelHeight};
    }
    input {
        margin-left: auto;
        margin-right: auto;
        max-width: 150px;
        font-weight: bold;
    }
    .toggleLabels {
        margin-left: ${props => props.toggleLabelMargin};
        margin-right: ${props => props.toggleLabelMargin};
    }
    
    .custom-switch {
        margin-left: auto;
        margin-right: auto;
    }
`;

export default ChargeDelayControl;